var currentTab = 0; // Current tab is set to be the first tab (0)
showTab(currentTab); // Display the current tab
document.querySelector(".steps").style.display = "none";
var prevTab = 0;

// global variable to store selected prescription file
var presc_files = null
var presc_file_url = null

function showTab(n) {
  // This function will display the specified tab of the form...
  var x = document.getElementsByClassName("step");
  x[n].style.display = "block";
  //... and fix the Previous/Next buttons:
  if (n <= 1) {
    document.getElementById("prevBtn").style.display = "none";
  } else {
    document.getElementById("prevBtn").style.display = "inline";
  }
  //... and run a function that will display the correct step indicator:
  fixStepIndicator(n);
}

var flowPath = null; // "prescription" | "frame" | "tint" — set at Step 1
var flowMode = "cart"; // "cart" | "insurance" | "contact" — set by the button that opens the wizard

function updateLensPreview() {
  var preview = document.querySelector(".product-regular-modal .lens-preview");
  if (!preview) return;

  var framePreview = document.querySelector(".product-regular-modal .frame-preview");
  var showPreview = flowPath === "tint" && currentTab === 3;
  preview.style.display = showPreview ? "block" : "none";
  if (framePreview) framePreview.style.display = showPreview ? "none" : "";
  if (!showPreview) return;

  var fill = preview.querySelector("#lensFill");
  var fadeTop = preview.querySelector("#lensFadeTop");
  var fadeBottom = preview.querySelector("#lensFadeBottom");
  if (!fill) return;

  var colors = {
    Pink: "#ffbbdf",
    Blue: "#85bdd6",
    Grey: "#8f9295",
    Brown: "#8b5a3c",
    Purple: "#d99ce1",
    Green: "#78916e",
    Yellow: "#fafc9e",
    Orange: "#d48a6a"
  };
  var tintColor = document.querySelector('[name="properties[Tint Color]"]:checked');
  var polarizedColor = document.querySelector('[name="properties[Polarized Color]"]:checked');
  var density = document.querySelector('[name="properties[Tint Density]"]:checked');
  var fade = document.querySelector('[name="properties[Tint Fade]"]:checked');
  var selectedColor = tintColor || polarizedColor;
  var color = selectedColor ? colors[selectedColor.value] : "#cfd2d6";
  var opacity = density
    ? parseInt(density.value, 10) / 100
    : (tintColor ? 0.8 : (polarizedColor ? 0.72 : 0));

  if (fade && fadeTop && fadeBottom) {
    fadeTop.setAttribute("stop-color", color);
    fadeTop.setAttribute("stop-opacity", opacity);
    fadeBottom.setAttribute("stop-color", color);
    fadeBottom.setAttribute("stop-opacity", "0");
    fill.setAttribute("fill", "url(#lensFadeGrad)");
    fill.setAttribute("fill-opacity", "1");
  } else {
    fill.setAttribute("fill", color);
    fill.setAttribute("fill-opacity", opacity);
  }
}

function currentSeq() {
  if (flowPath === "tint") {
    var use = document.querySelector('[name="properties[Use of glasses]"]:checked');
    if (use && use.value === "No Prescription") return [1, 2, 3];
    return [1, 2, 3, 5];
  }
  if (flowPath === "prescription") return [1, 2, 3, 5];
  return [1];
}

function configureStepForPath() {
  var tint = flowPath === "tint";
  document.querySelectorAll('label[for="no_prescription"]').forEach(function (l) {
    l.style.display = tint ? "block" : "none";
  });
  document.querySelectorAll(".coating_section, .photochromatic_section").forEach(function (s) {
    s.style.display = tint ? "none" : "block";
  });
  if (tint) {
    var l2c = document.querySelector(".lens_to_color_section");
    if (l2c) l2c.style.display = "none";
  }
  document.querySelectorAll(".tint_polarized_section").forEach(function (s) {
    s.style.display = tint ? "block" : "none";
  });
  document.querySelectorAll('[name="properties[Lens Finish]"]').forEach(function (v) {
    v.disabled = !tint;
    if (!tint) {
      v.checked = false;
      if (v.nextElementSibling) v.nextElementSibling.classList.remove("active");
    }
  });
  updatePolarizedReveal();
  updateLensPreview();
}

function updatePolarizedReveal() {
  var finish = document.querySelector('[name="properties[Lens Finish]"]:checked');
  var isPol = finish && finish.getAttribute("data-finish") === "Polarized";
  var isTint = finish && finish.getAttribute("data-finish") === "Color Tint";
  var polSection = document.querySelector(".polarized_color_section");
  var tintSection = document.querySelector(".tint_options_section");
  if (polSection) polSection.style.display = isPol ? "block" : "none";
  if (tintSection) tintSection.style.display = isTint ? "block" : "none";
  document.querySelectorAll('[name="properties[Polarized Color]"]').forEach(function (v) {
    v.disabled = !isPol;
    if (!isPol) {
      v.checked = false;
      if (v.nextElementSibling) v.nextElementSibling.classList.remove("active");
    }
  });
  document
    .querySelectorAll('[name="properties[Tint Color]"], [name="properties[Tint Density]"], [name="properties[Tint Fade]"]')
    .forEach(function (v) {
      v.disabled = !isTint;
      if (!isTint) {
        v.checked = false;
        if (v.nextElementSibling) v.nextElementSibling.classList.remove("active");
      }
    });
}

function stepHasValidSelection(stepIndex) {
  if (stepIndex === 1) {
    return !!document.querySelector('[name="properties[Purchase Lens]"]:checked');
  }
  if (stepIndex === 2) {
    var use = document.querySelector('[name="properties[Use of glasses]"]:checked');
    if (!use) return false;
    if (use.value === "Reading") {
      var ap = document.querySelector('[name="properties[Add power on prescription]"]:checked');
      return !!(ap && ap.value === "Yes");
    }
    return true;
  }
  if (stepIndex === 3) {
    var mat = document.querySelector('[name="properties[Lens Material]"]:checked');
    if (flowPath === "tint") {
      if (!mat) return false;
      var finish = document.querySelector('[name="properties[Lens Finish]"]:checked');
      if (!finish) return false;
      if (finish.getAttribute("data-finish") === "Polarized") {
        return !!document.querySelector('[name="properties[Polarized Color]"]:checked');
      }
      if (finish.getAttribute("data-finish") === "Color Tint") {
        return !!(
          document.querySelector('[name="properties[Tint Color]"]:checked') &&
          document.querySelector('[name="properties[Tint Density]"]:checked')
        );
      }
      return false;
    }
    var coat = document.querySelector('[name="properties[Lens Coating]"]:checked');
    var photo = document.querySelector('[name="properties[Add Transition Lens]"]:checked');
    if (!(mat && coat && photo)) return false;
    if (photo.value === "Yes") {
      return !!document.querySelector('[name="properties[Transition Color]"]:checked');
    }
    return true;
  }
  if (stepIndex === 5) {
    var p = document.querySelector('[name="properties[Prescription]"]:checked');
    if (!p) return false;
    if (p.value === "Previous Customer") {
      var s = document.querySelector('[name="properties[Store]"]');
      return !!(s && s.value !== "");
    }
    if (p.value === "Upload File") {
      var f = document.querySelector('[name="prescription_file"]');
      return !!(f && f.value !== "");
    }
    return true;
  }
  return true;
}

function updateNextLabel() {
  var seq = currentSeq();
  var isLast = seq[seq.length - 1] === currentTab;
  var insurance = document.querySelector('[name="properties[Insurance]"]:checked');
  if (isLast) {
    nextBtn.innerHTML =
      flowMode === "contact"
        ? "Fill contact form"
        : insurance && insurance.value === "Yes insurance"
        ? "Fill vision insurance form"
        : "Add to Cart";
  } else {
    var nxt = seq[seq.indexOf(currentTab) + 1];
    nextBtn.innerHTML =
      nxt === 2
        ? "Choose Glasses Type"
        : nxt === 3
        ? "Choose lens material"
        : nxt === 5
        ? "Provide prescription"
        : "Next Step";
  }
  nextBtn.disabled = !stepHasValidSelection(currentTab);
}

function finishFlow() {
  if (flowMode === "contact") {
    $("#glassesData").css("display", "none");
    $("#contactForm").css("display", "block");
    nextPrevBtn.style.display = "none";
    injectSelections(document.querySelector("#contactForm form"));
    return false;
  }
  var insurance = document.querySelector('[name="properties[Insurance]"]:checked');
  if (insurance && insurance.value === "Yes insurance") {
    $("#glassesData").css("display", "none");
    $("#insuranceForm").css("display", "block");
    nextPrevBtn.style.display = "none";
    injectSelections(document.querySelector("#insuranceForm form"));
    return false;
  }
  nextBtn.innerHTML = "Add to Cart";
  prevBtn.disabled = true;
  document.querySelector("#glassesData .loader").style.display = "block";
  var addToCartForm = document.querySelector('[action="/cart/add"]');
  var element = document.querySelector("#glassesData").cloneNode(true);
  element.style.display = "none";
  addToCartForm.append(element);
  addToCartForm.requestSubmit();
  return false;
}

function nextPrev(e, n) {
  var action = e.getAttribute("data-action");
  var x = document.getElementsByClassName("step");
  var seq = currentSeq();
  var pos = seq.indexOf(currentTab);
  if (pos === -1) pos = 0;
  prevTab = currentTab;

  if (action === "next") {
    if (!validateForm()) return false;
    if (!stepHasValidSelection(currentTab)) return false;
    if (pos + 1 >= seq.length) {
      return finishFlow();
    }
    x[currentTab].style.display = "none";
    currentTab = seq[pos + 1];
  } else {
    if (pos - 1 < 0) return false;
    x[currentTab].style.display = "none";
    currentTab = seq[pos - 1];
  }

  document.querySelector(".steps").style.display = currentTab < 2 ? "none" : "flex";
  document.getElementsByClassName("stepIndicator")[currentTab].classList.remove("finish");
  configureStepForPath();
  showTab(currentTab);
  updateNextLabel();
  return false;
}

function validateForm() {
  // This function deals with validation of the form fields
  var x,
    y,
    i,
    valid = true;
  x = document.getElementsByClassName("step");
  y = x[currentTab].getElementsByTagName("input");
  // A loop that checks every input field in the current tab:
  for (i = 0; i < y.length; i++) {
    // If a field is empty...
    if (y[i].value == "") {
      // add an "invalid" class to the field:
      y[i].className += " invalid";
      // and set the current valid status to false
      valid = false;
    }
  }
  // If the valid status is true, mark the step as finished and valid:
  valid = true;
  if (valid) {
    document.getElementsByClassName("stepIndicator")[currentTab].className +=
      " finish";
  }
  return valid; // return the valid status
}

function fixStepIndicator(n) {
  // This function removes the "active" class of all steps...
  var i,
    x = document.getElementsByClassName("stepIndicator");
  for (i = 0; i < x.length; i++) {
    x[i].className = x[i].className.replace(" active", "");
  }
  //... and adds the "active" class on the current step:
  x[n].className += " active";
}

function resetForm() {
  presc_files = null
  presc_file_url = null
  flowMode = "cart";
  $(".product-regular-modal").removeClass("no-prices");

  var selectors = document.querySelectorAll(
    `[name="properties[Use of glasses]"], [name="properties[Add power on prescription]"],
[name="properties[Lens Material]"],
[name="properties[Lens Coating]"],
[name="properties[Add Transition Lens]"],
[name="properties[Transition Color]"],
[name="properties[Prescription]"],
[name="properties[Insurance]"],
[name="properties[Purchase Lens]"],
[name="properties[Lens Finish]"],
[name="properties[Polarized Color]"],
[name="properties[Tint Color]"],
[name="properties[Tint Density]"],
[name="properties[Tint Fade]"]
`
  );
  selectors.forEach(function (value) {
    value.checked = false;
    if (value.nextElementSibling) {
      value.nextElementSibling.classList.remove("active");
    }
    $(".store_section").css("display", "none");
    $(".upload_section").css("display", "none");
    document.querySelector('[name="properties[Store]"]').selectedIndex = 0;
    document.querySelector('[name="prescription_file"]').value = "";
    document.querySelectorAll(".step").forEach(function (value, index) {
      value.style.display = "none";
      document
        .getElementsByClassName("stepIndicator")
      [index].classList.remove("finish");
    });
    currentTab = 0;
    document.querySelector(".steps").style.display = "none";
    document.querySelector("#selected_list").innerHTML = "";
    nextBtn.disabled = true;
    nextBtn.innerHTML = "Next";
    showTab(0);
  });

  flowPath = null;
  configureStepForPath();
  document.querySelector(".reading_sec").style.display = "none";
  var readingNote = document.querySelector("#glassesData .note");
  if (readingNote) readingNote.style.display = "none";
  document.querySelectorAll(".polarized_color_section, .tint_options_section").forEach(function (s) {
    s.style.display = "none";
  });
  document.querySelector("#insuranceForm > form").reset();
  document.querySelector('#insuranceForm [type="submit"]').disabled = false;
 
  $("#insuranceForm .insuranceCard").css("display", "none");
  $("#insuranceForm .Member-ID").css("display", "none");
  $("#insuranceForm").css("display", "none");
  $("#contactForm").css("display", "none");
  $("#glassesData").css("display", "block");
  nextPrevBtn.style.display = "block";

  $("insuranceForm #files_hidden_c").value = "";
  $("#insuranceForm .upload_file_input").css("display", "block");
  $("#insuranceForm .uploaded_file").css("display", "none");
}

function presetInsurance(value) {
  var radio = document.querySelector(
    '[name="properties[Insurance]"][value="' + value + '"]'
  );
  if (!radio) return;
  radio.checked = true;
  prevBtn.disabled = false;
  var loader = document.querySelector("#glassesData .loader");
  if (loader) loader.style.display = "none";
  var x = document.getElementsByClassName("step");
  x[0].style.display = "none";
  prevTab = 0;
  currentTab = 1;
  configureStepForPath();
  showTab(1);
  updateNextLabel();
}

var selectors = document.querySelectorAll(
  `[name="properties[Use of glasses]"], [name="properties[Add power on prescription]"],
[name="properties[Lens Material]"],
[name="properties[Lens Coating]"],
[name="properties[Add Transition Lens]"],
[name="properties[Transition Color]"],
[name="properties[Prescription]"],
[name="properties[Insurance]"],
[name="properties[Purchase Lens]"],
[name="properties[Lens Finish]"],
[name="properties[Polarized Color]"],
[name="properties[Tint Color]"],
[name="properties[Tint Density]"],
[name="properties[Tint Fade]"],
#insuranceForm [name="contact[how_would_you_like_to_provide_your_member_id?]"],
#insuranceForm [name="contact[do_you_want_us_to_email_or_call_you_to_explain_your_benefits?]"]
`
);

document
  .querySelector('#insuranceForm [name="contact[insurance_card_file]"]')
  .addEventListener("change", function (e) {
    if (this.files.length > 0) {
      $("#insuranceForm .uploaded_file h6").text(this.files[0].name);
      $("#insuranceForm .uploaded_file p").text(
        formatFileSize(this.files[0].size)
      );
      $("#insuranceForm .uploaded_file").css("display", "flex");
      $("#insuranceForm .upload_file_input").css("display", "none");
    }
  });

selectors.forEach(function (value) {
  value.addEventListener("click", function (e) {
    var activeModal = this.closest(".product-regular-modal") || document;
    activeModal
      .querySelectorAll('[name="' + this.name + '"]')
      .forEach(function (r) {
        if (r.nextElementSibling) {
          r.nextElementSibling.classList.remove("active");
        }
      });
    this.nextElementSibling.classList.add("active");

    var nextBtn = document.querySelector("#nextBtn");

    var insurance = document.querySelector(
      '[name="properties[Insurance]"]:checked'
    );

    if (currentTab == 0) {
      if (insurance && insurance.value == "Yes insurance") {
        nextBtn.innerHTML = "Fill vision insurance form";
      } else if (insurance && insurance.value == "No insurance") {
        nextBtn.innerHTML = "Next Step";
      }
      nextBtn.disabled = false;
    }

    var insurance = document.querySelector(
      '[name="properties[Purchase Lens]"]:checked'
    );

    if (currentTab == 1) {
      if (insurance) {
        flowPath =
          insurance.value === "With lens"
            ? "prescription"
            : insurance.value === "With frame only"
            ? "frame"
            : "tint";
        configureStepForPath();
        if (insurance.value === "Tint or Polarized") {
          document
            .querySelectorAll(
              `[name="properties[Use of glasses]"], [name="properties[Add power on prescription]"],
[name="properties[Lens Material]"],
[name="properties[Prescription]"],
[name="prescription_file"],
[name="properties[Store]"]
`
            )
            .forEach(function (value) {
              value.disabled = false;
            });
          document
            .querySelectorAll(
              `[name="properties[Lens Coating]"],
[name="properties[Add Transition Lens]"],
[name="properties[Transition Color]"]
`
            )
            .forEach(function (value) {
              value.disabled = true;
              value.checked = false;
            });
        }
      }
      if (insurance && insurance.value == "With lens") {
        nextBtn.innerHTML = "Choose Glasses Type";
        var prescription = document.querySelector(
          '[name="properties[Prescription]"]:checked'
        );
        document
          .querySelectorAll(
            `[name="properties[Use of glasses]"], [name="properties[Add power on prescription]"],
[name="properties[Lens Material]"],
[name="properties[Lens Coating]"],
[name="properties[Add Transition Lens]"],
[name="properties[Transition Color]"],
[name="properties[Prescription]"],
[name="prescription_file"],
[name="properties[Store]"]
`
          )
          .forEach(function (value) {
            value.disabled = false;
          });
        if (prescription && prescription.value != "Previous Customer") {
          document.querySelector('[name="properties[Store]"]').disabled = true;
        }
      } else if (insurance && insurance.value == "With frame only") {
        nextBtn.innerHTML = "Add to Cart";
        document
          .querySelectorAll(
            `[name="properties[Use of glasses]"], [name="properties[Add power on prescription]"],
[name="properties[Lens Material]"],
[name="properties[Lens Coating]"],
[name="properties[Add Transition Lens]"],
[name="properties[Transition Color]"],
[name="properties[Prescription]"],
[name="prescription_file"],
[name="properties[Store]"]
`
          )
          .forEach(function (value) {
            value.disabled = true;
          });
      }
      nextBtn.disabled = false;
    }

    if (currentTab == 2) {
      var glasses_type = document.querySelector(
        '[name="properties[Use of glasses]"]:checked'
      );
      if (glasses_type) {
        nextBtn.innerHTML = "Choose lens material";
        // if(glasses_type.value == 'Distance') {
        //   nextBtn.disabled = false;
        // } else if(glasses_type.value == 'Reading') {
        //   nextBtn.disabled = true;
        //   var add_power = document.querySelector('[name="properties[Add power on prescription]"]:checked');
        //   if(add_power) {
        //     nextBtn.disabled = false;
        //   }
        // }
      }
    }
    if (currentTab == 3) {
      var lens_material = document.querySelector(
        '[name="properties[Lens Material]"]:checked'
      );
      var coating = document.querySelector(
        '[name="properties[Lens Coating]"]:checked'
      );
      if (lens_material && coating) {
        nextBtn.innerHTML = "Choose addons";
        nextBtn.disabled = false;
      }
    }

    var photochromic = document.querySelector(
      '[name="properties[Add Transition Lens]"]:checked'
    );

    var member_id_opt_contact = document.querySelector(
      '#insuranceForm [name="contact[how_would_you_like_to_provide_your_member_id?]"]:checked'
    );
    
    if (
      member_id_opt_contact &&
      member_id_opt_contact.value == "Enter your Member ID"
    ) {
      document.querySelector("#insuranceForm .Member-ID").style.display =
        "block";
      document.querySelector(
        '#insuranceForm [name="contact[please_enter_your_member_id ]"]'
      ).disabled = false;
      document.querySelector("#insuranceForm .insuranceCard").style.display =
        "none";
      document.querySelector("#insuranceForm .uploaded_file").style.display =
        "none";
      document.querySelector(
        '#insuranceForm [name="contact[insurance_card_file]"]'
      ).disabled = true;
      document.querySelector(
        '#insuranceForm [name="contact[please_upload_a_picture_of_your_insurance_card]"]'
      ).disabled = true;
    } else if (
      member_id_opt_contact &&
      member_id_opt_contact.value == "Upload a picture of your insurance card"
    ) {
      document.querySelector("#insuranceForm .Member-ID").style.display =
        "none";
      document.querySelector(
        '#insuranceForm [name="contact[please_enter_your_member_id ]"]'
      ).disabled = true;
      document.querySelector("#insuranceForm .insuranceCard").style.display =
        "block";
      if (
        document.querySelector(
          '#insuranceForm [name="contact[insurance_card_file]"]'
        ).files.length > 0
      ) {
        document.querySelector("#insuranceForm .uploaded_file").style.display =
          "flex";
      }
      document.querySelector(
        '#insuranceForm [name="contact[insurance_card_file]"]'
      ).disabled = false;
      document.querySelector(
        '#insuranceForm [name="contact[please_upload_a_picture_of_your_insurance_card]"]'
      ).disabled = false;
    }

    
    // reading section
    var reading_sec = document.querySelector(".reading_sec");
    if (reading_sec && glasses_type && glasses_type.value == "Reading") {
      if (!nextBtn.disabled) {
        nextBtn.disabled = true;
      }
      reading_sec.style.display = "block";
      document
        .querySelectorAll(
          '.reading_sec [name="properties[Add power on prescription]"]'
        )
        .forEach(function (value) {
          value.disabled = false;
        });
      var add_power = document.querySelector(
        '[name="properties[Add power on prescription]"]:checked'
      );
      if (add_power) {
        nextBtn.disabled = false;
      }
      if (add_power && add_power.value == "No") {
        document.querySelector("#glassesData .note").style.display = "flex";
        nextBtn.disabled = true;
      } else {
        document.querySelector("#glassesData .note").style.display = "none";
      }
    } else if (
      reading_sec &&
      glasses_type &&
      glasses_type.value != "Reading"
    ) {
      nextBtn.disabled = false;
      reading_sec.style.display = "none";
      document
        .querySelectorAll(
          '.reading_sec [name="properties[Add power on prescription]"]'
        )
        .forEach(function (value) {
          value.disabled = true;
          value.checked = false;
          if (value.nextElementSibling) {
            value.nextElementSibling.classList.remove("active");
          }
        });
    }
    var lens_to_color_section = document.querySelector(
      ".lens_to_color_section"
    );
    if (lens_to_color_section && photochromic && photochromic.value == "Yes") {
      if (!nextBtn.disabled) {
        nextBtn.disabled = true;
      }
      lens_to_color_section.style.display = "block";
      document
        .querySelectorAll(
          '.lens_to_color_section [name="properties[Transition Color]"]'
        )
        .forEach(function (value) {
          value.disabled = false;
        });
      var transition_color = document.querySelector(
        '[name="properties[Transition Color]"]:checked'
      );
      if (transition_color) {
        nextBtn.disabled = false;
      }
    } else if (
      lens_to_color_section &&
      photochromic &&
      photochromic.value == "No"
    ) {
      nextBtn.disabled = false;
      lens_to_color_section.style.display = "none";
      document
        .querySelectorAll(
          '.lens_to_color_section [name="properties[Transition Color]"]'
        )
        .forEach(function (value) {
          value.disabled = true;
        });
    }
    var store_section = document.querySelector(".store_section");
    var upload_section = document.querySelector(".upload_section");
    if (e.target.value == "Previous Customer") {
      nextBtn.disabled = true;
      store_section.style.display = "block";
      upload_section.style.display = "none";
      document.querySelector(
        '.store_section [name="properties[Store]"]'
      ).disabled = false;
      document.querySelector(
        '.upload_section [name="prescription_file"]'
      ).disabled = true;
      var store_you_go = document.querySelector('[name="properties[Store]"]');
      if (store_you_go && store_you_go.value != "") {
        nextBtn.disabled = false;
      }
    } else if (e.target.value == "Upload File") {
      nextBtn.disabled = true;
      store_section.style.display = "none";
      upload_section.style.display = "block";
      document.querySelector(
        '.store_section [name="properties[Store]"]'
      ).disabled = true;
      document.querySelector(
        '.upload_section [name="prescription_file"]'
      ).disabled = false;
      var prescription_file = document.querySelector(
        '[name="prescription_file"]'
      );
      if (prescription_file && prescription_file.value != "") {
        nextBtn.disabled = false;
      }
    } else if (e.target.value == "Email it later") {
      nextBtn.disabled = false;
      store_section.style.display = "none";
      upload_section.style.display = "none";
      document.querySelector(
        '.store_section [name="properties[Store]"]'
      ).disabled = true;
      document.querySelector(
        '.upload_section [name="prescription_file"]'
      ).disabled = true;
    }
    updatePolarizedReveal();
    if (this.name === "properties[Lens Finish]") {
      var card = this.closest(".polarized_card");
      if (card) card.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    if (this.name === "properties[Use of glasses]" && this.value === "Reading") {
      var rsec = document.querySelector(".reading_sec");
      if (rsec && getComputedStyle(rsec).display !== "none") {
        rsec.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
    refreshList();
    updateNextLabel();
    updateLensPreview();
  });
});

document
  .querySelectorAll(
    '[name="properties[Tint Color]"], [name="properties[Polarized Color]"], [name="properties[Tint Density]"], [name="properties[Tint Fade]"]'
  )
  .forEach(function (value) {
    value.addEventListener("change", updateLensPreview);
  });

function refreshList() {
  var selected_list = document.querySelector("#selected_list");
  selected_list.innerHTML = "";
  var selectors_for_list = document.querySelectorAll(
    `[name="properties[Use of glasses]"], [name="properties[Add power on prescription]"],
[name="properties[Lens Material]"],
[name="properties[Lens Coating]"],
[name="properties[Add Transition Lens]"],
[name="properties[Transition Color]"],
[name="properties[Prescription]"],
[name="properties[Store]"],
[name="properties[Lens Finish]"],
[name="properties[Polarized Color]"],
[name="properties[Tint Color]"],
[name="properties[Tint Density]"],
[name="properties[Tint Fade]"]
`
  );
  selectors_for_list.forEach(function (value) {
    if (
      (value.checked || (value.value && value.name == "properties[Store]")) &&
      !value.disabled
    ) {
      var display = value.value;
      if (flowMode === "insurance") {
        display = display.replace(/\s*\(\+\$[\d.,]+\)/g, "");
      }
      selected_list.innerHTML += `<h3>${value.name.replace(
        /properties\[(.*?)\]/,
        "$1"
      )} : <span>${display}</span></h3>`;
    }
  });
}

function collectSelections() {
  var data = [];
  try {
    var vd = JSON.parse(
      document.querySelector("[data-frame-variants]").textContent
    );
    var idEl = document.querySelector('[action="/cart/add"] [name="id"]');
    var vid = idEl ? parseInt(idEl.value, 10) : null;
    var variant =
      vd.variants.find(function (v) { return v.id === vid; }) || vd.variants[0];
    if (variant) {
      vd.options.forEach(function (name, i) {
        if (variant.opts[i] && variant.opts[i] !== "Default Title") {
          data.push(["Frame " + name, variant.opts[i]]);
        }
      });
    }
  } catch (e) {}
  var selectors_for_list = document.querySelectorAll(
    `[name="properties[Use of glasses]"], [name="properties[Add power on prescription]"],
[name="properties[Lens Material]"],
[name="properties[Lens Coating]"],
[name="properties[Add Transition Lens]"],
[name="properties[Transition Color]"],
[name="properties[Prescription]"],
[name="properties[Store]"],
[name="properties[Lens Finish]"],
[name="properties[Polarized Color]"],
[name="properties[Tint Color]"],
[name="properties[Tint Density]"],
[name="properties[Tint Fade]"]
`
  );
  selectors_for_list.forEach(function (value) {
    if (
      (value.checked || (value.value && value.name == "properties[Store]")) &&
      !value.disabled
    ) {
      var val = value.value.replace(/\s+/g, " ").trim();
      if (flowMode === "insurance") {
        val = val.replace(/\s*\(\+\$[\d.,]+\)/g, "");
      }
      data.push([value.name.replace(/properties\[(.*?)\]/, "$1"), val]);
    }
  });
  var presc_choice = document.querySelector(
    '[name="properties[Prescription]"]:checked'
  );
  if (
    presc_choice &&
    !presc_choice.disabled &&
    presc_choice.value === "Upload File" &&
    presc_file_url
  ) {
    data.push(["Prescription File", presc_file_url]);
  }
  return data;
}

function prescriptionUploadPending() {
  var choice = document.querySelector(
    '[name="properties[Prescription]"]:checked'
  );
  return !!(
    choice &&
    !choice.disabled &&
    choice.value === "Upload File" &&
    presc_files &&
    !presc_file_url
  );
}

async function uploadPrescriptionIfNeeded() {
  if (!prescriptionUploadPending()) return;
  var url = await uploadFileToS3Bucket(presc_files, "prescriptions/");
  if (url) presc_file_url = url;
}

function injectSelections(form) {
  form.querySelectorAll(".injected-selection").forEach(function (el) {
    el.remove();
  });
  collectSelections().forEach(function (pair) {
    var input = document.createElement("input");
    input.type = "hidden";
    input.className = "injected-selection";
    input.name = "contact[" + pair[0] + "]";
    input.value = pair[1];
    form.appendChild(input);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".prevBtn").forEach(function (value) {
    value.addEventListener("click", function () {
      $("#glassesData").css("display", "block");
      $("#insuranceForm").css("display", "none");
      $("#contactForm").css("display", "none");
      nextPrevBtn.style.display = "block";
      // Restore the wizard to the step we left from, so the step indicator
      // reflects the real position (not a stale "finish"/highlight on the
      // last step — which lit the connector past step 2 on skipped flows).
      document
        .getElementsByClassName("stepIndicator")
        [currentTab].classList.remove("finish");
      document.querySelector(".steps").style.display =
        currentTab < 2 ? "none" : "flex";
      showTab(currentTab);
      updateNextLabel();
    });
  });
  var contactUsForm = document.querySelector("#contactForm form");
  if (contactUsForm) {
    contactUsForm.addEventListener("submit", function (e) {
      if (contactUsForm.dataset.uploadDone === "1") {
        contactUsForm.dataset.uploadDone = "";
        injectSelections(contactUsForm);
        return;
      }
      if (prescriptionUploadPending()) {
        e.preventDefault();
        var btn = contactUsForm.querySelector('[type="submit"]');
        var label = btn ? btn.innerHTML : "";
        if (btn) {
          btn.innerHTML = "Please wait...";
          btn.disabled = true;
        }
        uploadPrescriptionIfNeeded().then(function () {
          if (btn) {
            btn.innerHTML = label;
            btn.disabled = false;
          }
          contactUsForm.dataset.uploadDone = "1";
          contactUsForm.requestSubmit();
        });
        return;
      }
      injectSelections(contactUsForm);
    });
  }
  document
    .querySelectorAll('[name="properties[Store]"], [name="prescription_file"]')
    .forEach(function (value) {
      value.addEventListener("change", function (e) {
        if (this.value != "") {
          nextBtn.disabled = false;
        }
        if (this.name == "properties[Store]") {
          var options = this.options;
          for (var i = 0; i < options.length; i++) {
            options[i].removeAttribute("selected");
          }
          this.options[this.selectedIndex].setAttribute("selected", "selected");
        }

        if (this.name == "prescription_file") {
          if (this.files.length > 0) {
            presc_files = this.files
            $("#glassesData .uploaded_file h6").text(this.files[0].name);
            $("#glassesData .uploaded_file p").text(formatFileSize(this.files[0].size));
            $("#glassesData .uploaded_file").css("display", "flex");
            $("#glassesData .upload_file_input").css("display", "none");
          }
        }
        setTimeout(function () {
          refreshList();
        }, 100);
      });
    });
  document.querySelector(".closeImg").addEventListener("click", function (e) {
    e.preventDefault();
    resetForm();
    document.querySelector(".product-regular-modal").style.display = "none";
    $("#shopify-chat").attr("style", "display: block !important");

    // enable background scroll
    $("body").css("overflow", "auto");
    let body = document.body;
    let scrollY = body.style.top;
    body.style.position = "";
    body.style.top = "";
    body.style.height = "";
    body.style.overflowY = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
  });
  document
    .querySelector("#glassesData .file_close")
    .addEventListener("click", function () {
      nextBtn.disabled = true;
      document.querySelector('#glassesData [name="prescription_file"]').value =
        "";
      $("#glassesData .uploaded_file").css("display", "none");
      $("#glassesData .upload_file_input").css("display", "block");
    });
  document
    .querySelector("#insuranceForm .file_close")
    .addEventListener("click", function () {
      nextBtn.disabled = true;
      document.querySelector(
        '#insuranceForm [name="contact[insurance_card_file]"]'
      ).value = "";
      document.querySelector(
        '#insuranceForm [name="contact[insurance_card_file]"]'
      ).disabled = false;
      document.querySelector(
        '#insuranceForm [name="contact[please_upload_a_picture_of_your_insurance_card]"]'
      ).value = "";
      $("#insuranceForm .uploaded_file").css("display", "none");
      $("#insuranceForm .upload_file_input").css("display", "block");
    });
  const addToCartButtons = document.querySelectorAll('button[name="add"]'); // Modify selector as needed

  document
    .querySelector('#insuranceForm [type="submit"]')
    .addEventListener("click", async function (event) {
      event.preventDefault();
      var member_id_opt_contact = document.querySelector(
        '#insuranceForm [name="contact[how_would_you_like_to_provide_your_member_id?]"]:checked'
      );
      var form = document.querySelector("#insuranceForm form");
      if (
        member_id_opt_contact &&
        member_id_opt_contact.value == "Upload a picture of your insurance card"
      ) {
        this.innerHTML = "Please wait...";
        this.disabled = true;

        var insurance_files = document.querySelector("#insuranceForm #files_c").files
        var url = await uploadFileToS3Bucket(
          insurance_files,
          "insurance_cards/"
        );
        if (url !== undefined) {
          document.querySelector("#insuranceForm #files_c").disabled = true;
          var files_hidden_contact = form.querySelector("#files_hidden_c");
          files_hidden_contact.value = url;
        }
        this.innerHTML = "Submit";
        this.disabled = false;
      }
      if (prescriptionUploadPending()) {
        this.innerHTML = "Please wait...";
        this.disabled = true;
        await uploadPrescriptionIfNeeded();
        this.innerHTML = "Submit";
        this.disabled = false;
      }
      injectSelections(form);
      form.requestSubmit();
      /*
      let formData = new FormData(form);
    let formDataObject = {};
    formData.forEach(function(value, key){
        formDataObject[key] = value;
    });

    console.log("Form data:", formDataObject);
    // comment till here */
    });

  addToCartButtons.forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault(); // Prevents adding to cart
      if(button.classList.contains('disabled')) return;
      resetForm();
      $(".product-regular-modal").addClass("opened");
      $(".product-regular-modal").css("display", "block");
      $("#shopify-chat").attr("style", "display: none !important");



      // disable background scroll
      $("body").css("overflow", "hidden");
      const scrollY =
        document.documentElement.style.getPropertyValue("--scroll-y");
      const body = document.body;
      body.style.position = "fixed";
      body.style.top = `-${scrollY}`;
      presetInsurance("No insurance");
    });
  });

  document.querySelectorAll(".openInsuranceModal").forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      resetForm();
      flowMode = "insurance";
      $(".product-regular-modal").addClass("no-prices");
      $(".product-regular-modal").addClass("opened");
      $(".product-regular-modal").css("display", "block");
      $("#shopify-chat").attr("style", "display: none !important");

      // disable background scroll
      $("body").css("overflow", "hidden");
      const scrollY =
        document.documentElement.style.getPropertyValue("--scroll-y");
      const body = document.body;
      body.style.position = "fixed";
      body.style.top = `-${scrollY}`;
      presetInsurance("Yes insurance");
    });
  });

  document.querySelectorAll("#contact_to_buy").forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      resetForm();
      flowMode = "contact";
      $(".product-regular-modal").addClass("opened");
      $(".product-regular-modal").css("display", "block");
      $("#shopify-chat").attr("style", "display: none !important");

      // disable background scroll
      $("body").css("overflow", "hidden");
      const scrollY =
        document.documentElement.style.getPropertyValue("--scroll-y");
      const body = document.body;
      body.style.position = "fixed";
      body.style.top = `-${scrollY}`;
      presetInsurance("No insurance");
    });
  });
  var addToCartForm = document.querySelector(`[action="/cart/add"]`);

  addToCartForm.addEventListener("submit", async function (e) {
    e.preventDefault();
    var lens_material = document.querySelector(
      '[name="properties[Lens Material]"]:checked'
    );
    var coating = document.querySelector(
      '[name="properties[Lens Coating]"]:checked'
    );
    var lens_to_color = document.querySelector(
      '[name="properties[Transition Color]"]:checked'
    );

    let formData = {
      items: [],
    };

    if (lens_material) {
      formData.items.push({
        id: lens_material.getAttribute("data-variant-id"),
        quantity: document.querySelector(".js-qty__num").value,
      });
    }
    if (coating) {
      formData.items.push({
        id: coating.getAttribute("data-variant-id"),
        quantity: document.querySelector(".js-qty__num").value,
      });
    }
    if (lens_to_color) {
      formData.items.push({
        id: lens_to_color.getAttribute("data-variant-id"),
        quantity: document.querySelector(".js-qty__num").value,
      });
    }

    var lens_finish = document.querySelector(
      '[name="properties[Lens Finish]"]:checked'
    );
    if (lens_finish && lens_finish.getAttribute("data-variant-id")) {
      formData.items.push({
        id: lens_finish.getAttribute("data-variant-id"),
        quantity: document.querySelector(".js-qty__num").value,
      });
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then(async (data) => {
        var prescription = document.querySelector(
          '[name="properties[Prescription]"]:checked'
        );
        if (prescription && prescription.value == "Upload File") {
          var url = await uploadFileToS3Bucket(
            // Due to an issue in safari we are caching selected prescription file
            // in a global variable and using here.
            presc_files,
            "prescriptions/"
          );
          prescription.value = url ?? "";
        }
        this.submit();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });
});

function formatFileSize(bytes, decimalPoint) {
  if (bytes == 0) return "0 Bytes";
  var k = 1000,
    dm = decimalPoint || 2,
    sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

async function uploadFileToS3Bucket(files, directoryPath) {
  // Configure the AWS SDK to use DigitalOcean Spaces
  const spacesEndpoint = new AWS.Endpoint("sfo3.digitaloceanspaces.com");
  const s3 = new AWS.S3({
    endpoint: spacesEndpoint,
    accessKeyId: "DO00LUE9ZJ2FWA8GLF7E",
    secretAccessKey: "6I533Ebk48xVyw2wSVMo4ZoZQMxdjEHl9iH5LMyjmeY",
    region: "sfo3",
    httpOptions: {
      timeout: 300000, // 5 minutes
    },
    maxRetries: 3, // Maximum number of retries per request
    retryDelayOptions: { base: 100 }, // Initial retry delay in milliseconds (the delay grows exponentially)
  });

  if (!files.length) {
    return alert("Please choose a file to upload first.");
  }
  let file = files[0];

  // Generate the unique file name
  let fileName = directoryPath + formatFileName(file.name);

  const bucketName = "mottopticalapp";

  const uploadParams = {
    Bucket: bucketName,
    Key: fileName,
    Body: file,
    ACL: "public-read", // Or any ACL you prefer
  };
  fileUrl = `https://mottopticalapp.sfo3.digitaloceanspaces.com/` + fileName;
  // let upload = await s3.upload(uploadParams, function(err, data) {
  //   if (err) {
  //     console.log("Error", err);
  //   }
  //   if (data) {
  //     console.log("Upload Success", data.Location);
  //   }
  // });

  // Wrap the upload in a promise
  // let uploadPromise = new Promise((resolve, reject) => {
  //   const upload = new AWS.S3.ManagedUpload({
  //     service: s3, // Use the configured S3 instance
  //     params: uploadParams,
  //     partSize: 6 * 1024 * 1024, // Optional: Set the part size for multipart upload, e.g., 6MB
  //     queueSize: 1, // Optional: Set the concurrency for part uploads
  //   });

  //   upload.on('httpUploadProgress', function(evt) {
  //     console.log('Upload Progress', evt.loaded / evt.total);
  //   });

  //   upload.send(function(err, data) {
  //     if (err) {
  //       console.log('Error', err);
  //       reject(err);
  //     } else {
  //       console.log('Upload Success', data.Location);
  //       resolve(fileUrl); // Resolve with the file URL on success
  //     }
  //   });
  // });

  // // Wait for the promise to resolve
  // return await uploadPromise;

  try {
    const result = await s3.upload(uploadParams).promise();
    console.log("Upload Success", result.Location);
    // Return the file URL on successful upload
    return fileUrl;
  } catch (err) {
    console.log("Error", err);
    throw err; // Rethrow the error if upload failed
  }
}

function formatFileName(originalFileName) {
  // Replace spaces with underscores
  let fileNameWithoutSpaces = originalFileName.replace(/\s+/g, "_");

  // Extract the file extension and file name without extension
  let extension = fileNameWithoutSpaces.split(".").pop();
  let fileName = fileNameWithoutSpaces.slice(0, -(extension.length + 1));

  // Get the current time in ISO format, replace colons with hyphens to avoid issues in filenames
  let currentTime = new Date()
    .toISOString()
    .replace(/:\d+\.\d+Z$/, "Z")
    .replace(/:/g, "-");

  // Concatenate everything
  let newFileName = `${fileName}-${currentTime}.${extension}`;

  return newFileName;
}

function toggleIcon() {
  var tooltip = document.querySelector("#glassesData .tooltip");
  tooltip.style.display = tooltip.style.display == "none" ? "block" : "none";
}
